import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { StringTableService } from '../../services/string-table.service';
import { BaseComponent } from '../base/base.component';
import { Table } from '../table/table.component';


@Component({
  selector: 'app-data-accordion',
  templateUrl: './data-accordion.component.html',
  styleUrls: ['./data-accordion.component.scss']
})
export class DataAccordionComponent extends BaseComponent implements OnInit {

  @Input() accordions;
  @Input() isExpandedData;
  @Input() enableShowReport = true;
  @Input() dashboardView = false;
  @ViewChild('subAccordion') subAccordion;
  @Output() linkClicked = new EventEmitter<object>();
  @Output() expansion = new EventEmitter<object>();
  @Output() popupShow = new EventEmitter<object>();
  isExpanded = this.isExpandedData;
  header: AccordionRow;
  content: AccordionRow;
  noAttempt: string;
  showReportTitle: string;
  popupState: boolean;
  
  constructor(ele: ElementRef, protected stringTableService: StringTableService) {
    super(ele);
  }
  
  ngOnInit() {
    this.header = this.accordions.header;
    this.content = this.accordions.content;
    this.noAttempt = this.stringTableService.getString('labels', 'no-attempt');
    this.showReportTitle = this.stringTableService.getString('labels', 'show-report');
    this.isExpanded = this.isExpandedData;
  }

  onHeaderClick() {
    this.isExpanded = !this.isExpanded;
    this.expansion.emit({ isExpanded : this.isExpanded });

    if (!this.isExpanded && this.subAccordion) {
      this.subAccordion.isExpanded = false;
    }
  }

  tableLinkClicked(event) {
    this.linkClicked.emit(event);
  }

  accordianLinkClicked(event) {
    this.linkClicked.emit(event);
  }

  showTablePopup(event, accordianId, itemValue, pieChartType, applicationId) {
    const element = this.ele.nativeElement.firstElementChild.firstElementChild.lastElementChild.lastElementChild;
    if (this.enableShowReport) {
      event.stopPropagation();
      this.popupShow.emit({
        'event': event, 'accordianId': accordianId, 'itemValue': itemValue, 'pieChartType': pieChartType,
        'selectedElement': element ,  'applicationId': applicationId,
      });
      this.popupState = true;
    }
  }

  popupClose() {
    this.popupState = false;
  }
}



export class AccordionRow {
  type: AccordionRowTypes;
  desc: string;
  title: string | number;
  dueDate: string;
  applicationId: string | number;
  header: Table;
  table: Table;
  tableHeader: Array<string>;
  customRows: AccordionRow[];
  customText: string;
  percentText: string | number;
  accordions: Accordion[];
  chartData: {
    itemValue: number,
    totalValue: number,
    chartType: number
  };
  constructor(type, firstParam, secondParam?, thirdParam?, applicationId?, forthParam?) {
    this.type = type;
    switch (this.type) {
      case AccordionRowTypes.TITLE_DESC:
        this.title = firstParam;
        this.desc = secondParam;
        break;
      case AccordionRowTypes.TABLE:
        this.header = firstParam;
        this.table = secondParam;
        break;
      case AccordionRowTypes.POPUP_TABLE:
        this.header = firstParam;
        this.table = secondParam;
        break;
      case AccordionRowTypes.TABLE_HEADER:
        this.tableHeader = firstParam;
        break;
      case AccordionRowTypes.PIE_CHART:
        this.title = firstParam;
        this.desc = secondParam;
        this.chartData = thirdParam;
        break;
      case AccordionRowTypes.PIE_CHART_DASHBOARD:
        this.title = firstParam;
        this.desc = secondParam;
        this.chartData = thirdParam;
        this.dueDate = forthParam;
        this.applicationId = applicationId;
        break;
      case AccordionRowTypes.SINGLE_ROW:
        this.customText = firstParam;
        break;
      case AccordionRowTypes.PERCENT_BAR:
        this.title = firstParam;
        this.percentText = secondParam;
        break;
      case AccordionRowTypes.ACCORDION:
        this.accordions = firstParam;
        break;
      default:
        break;
    }
  }

}

export class Accordion {
  header: AccordionRow;
  content: AccordionRow;

  constructor(header, content) {
    this.header = header;
    this.content = content;
  }
}

export enum AccordionRowTypes {
  TITLE_DESC = 1,
  TABLE = 2,
  TABLE_HEADER = 3,
  CUSTOM = 4,
  SINGLE_ROW = 5,
  PERCENT_BAR = 6,
  ACCORDION = 7,
  PIE_CHART = 4,
  PIE_CHART_DASHBOARD = 8,
  POPUP_TABLE = 9,
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/data-accordion/data-accordion.component.ts